import "./App.css";

import Galaxy from "./components/Galaxy";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import logo from "./assets/images/logo.png";
function App() {
  return (
    <div>
      <div className="App">
        <div className="header">
          <div className="header-title">
            <img src={logo} alt="PME" />
            <h3 className="">PME Blockchain Life 2024 Reward</h3>
          </div>

          <p>Everyone’s a winner!</p>
          <p>Try your luck for a chance to win between 10 to 100 PME!</p>
        </div>

        <div className="body">
          <Outlet />
        </div>
      </div>

      <Galaxy />
      <ToastContainer />
    </div>
  );
}

export default App;
